module.exports = __webpack_public_path__ + "img/playbar_voice_3.4ac7df88.svg";